const onlyNumbersRegex = /[0-9]/;
export { onlyNumbersRegex };
